module.exports = __webpack_public_path__ + "static/media/57.5a0b1f86.jpg";